<taly-partner-banner/>
<div class="container">
    <taly-payment-option/>
    <taly-trusted-parterns/>
    <taly-partner-faq/>
    <taly-integration/>
    <taly-sell-with-taly/>
</div>
